import { useTable } from "react-table";
import { useStoreCurrency } from "../../../hooks/useStoreCurrency";
import { useMemo } from "react";
import primaryComponents from "../../primaryComponents";

const useViewGenerateWaybillTable = ({
  waybills,
  view,
  setWaybillQty,
  waybillQty,
  items,
  control,
  selected,
  selectedAll,
  toggleAll,
  someSelected,
  toggleItem,
}) => {
  const { store_currency } = useStoreCurrency();
  const columns = useMemo(
    () =>
      [
        view
          ? null
          : {
              Header: "Product Name",
              accessor: "cart_item_name",
              Cell: ({ cell: { value }, row }) => (
                <span>{row?.original?.item?.product_name || "N/A"}</span>
              ),
            },
        view
          ? {
              Header: (
                <span
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <primaryComponents.Checkbox
                    name="selectAll"
                    id="selectAll"
                    isChecked={selectedAll}
                    indeterminate={someSelected}
                    onChange={toggleAll}
                  />
                  <span>Product Name</span>
                </span>
              ),
              accessor: "cart_item_name",
              Cell: ({ row }) => {
                const item = row?.original;
                return (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <primaryComponents.Checkbox
                      name={`select-${item.item_id}`}
                      id={`select-${item.item_id}`}
                      isChecked={!!selected[item.item_id]}
                      onChange={() => toggleItem(item.item_id)}
                    />
                    <span>{item.cart_item_name}</span>
                  </span>
                );
              },
            }
          : null,
        {
          Header: "Initial Bill QTY",
          accessor: "quantity",
          Cell: ({ cell: { value }, row }) => (
            <span className="muted--text">
              {view
                ? row?.original?.quantity
                : row?.original?.item?.quantity || 0}
            </span>
          ),
        },
        {
          Header: "QTY Remaining In Order",
          accessor: "waybill_remaining_quantity",
          Cell: ({ cell: { value }, row }) => (
            <span className="muted--text">
              {view
                ? row?.original?.waybill_remaining_quantity
                : row?.original?.item?.waybill_remaining_quantity || 0}
            </span>
          ),
        },
        !view
          ? {
              Header: "Tracking Code",
              accessor: "id",
              Cell: ({ cell: { value } }) => <span>{value || "N/A"}</span>,
            }
          : null,
        view
          ? {
              Header: "Quantity To Waybill",
              accessor: "id",
              Cell: ({ row }) => {
                const item = row?.original;
                return (
                  <primaryComponents.InputFieldV2
                    control={control}
                    name={`qty_${item.item_id}`}
                    className="white"
                    type="number"
                    placeholder="Enter Value"
                    value={waybillQty[item.item_id] || ""}
                    onChange={({ target: { value } }) => {
                      setWaybillQty((prev) => ({
                        ...prev,
                        [item.item_id]: value,
                      }));
                    }}
                    isDisabled={!selected[item.item_id]}
                  />
                );
              },
            }
          : null,
      ].filter(Boolean),
    [items, selected, waybillQty, selectedAll, someSelected, control],
  );

  const instance = useTable({
    columns,
    data: view ? items : waybills?.waybill_items || [],
  });
  return { store_currency, instance };
};

export default useViewGenerateWaybillTable;
